<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 报警记录
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!-- <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >高级搜索</el-button>-->
                <!-- <el-select v-model="query.address" placeholder="地址" class="handle-select mr10">
                    <el-option key="1" label="广东省" value="广东省"></el-option>
                    <el-option key="2" label="湖南省" value="湖南省"></el-option>
                </el-select>-->
                <el-input v-model="query.name" placeholder="请输入IMEI或设备ID" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">刷新</el-button>
                <el-button type="primary" icon="el-icon-search" @click="exportExcel">导出记录</el-button>
            </div>
            <el-table
                :data="tableDatas"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                id="outExcel"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="150" align="center"></el-table-column>
                <el-table-column prop="IMEI" label="IMEI" width="180"></el-table-column>
                <el-table-column label="历史报警" align="center" width="90">
                    <template slot-scope="scope">
                        <span style="color: #409eff; cursor: pointer">查看</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="day" label="当日报警"></el-table-column>
                <el-table-column prop="days" label="总报警"></el-table-column>-->
                <el-table-column prop="deviceType" label="设备类型" width="120"></el-table-column>
                <el-table-column prop="address" label="安装点位"></el-table-column>

                <el-table-column prop="ss" label="报警水位/米" width="150">5.6</el-table-column>
                <el-table-column prop="ss" label="当前水位/米" width="150">5.3</el-table-column>
                <el-table-column prop="ems" align="center" label="短信状态" width="90">
                    <span style="color: #409eff; cursor: pointer">已发送</span>
                </el-table-column>
                <el-table-column prop="failDate" align="center" label="报警时间" width="180"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >处理</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-video-camera"
                            @click="handleVedio(scope.$index, scope.row)"
                        >查看录像</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="处理报警" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="70px">
                <el-form-item label="确认类型">
                    <el-select
                        v-model="cofimTypeValue"
                        @change="confimSelectChange"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in cofimTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="指派人员" v-if="confimPeopleShow">
                    <el-select v-model="cofimPeopleValue" placeholder="请选择">
                        <el-option
                            v-for="item in cofimPeopleOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="地址">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>-->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 视频弹出框 -->
        <el-dialog title="报警录像" :visible.sync="videoVisible" width="50%">
            <!-- <video controls class="videoClass" src="../../assets/img/vedio.mp4"></video> -->
        </el-dialog>

        <!-- 已发送短信人员 -->
        <el-dialog title="SD20220133已发送短信" :visible.sync="smsVisible" width="50%">
            <el-table
                :data="emsDatas"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                id="outExcel"
                @selection-change="handleSelectionChange"
            >
                <el-table-column prop="phone" label="手机号" width="180"></el-table-column>
                <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                <el-table-column prop="date" label="发送时间"></el-table-column>
                <el-table-column prop="status" label="发送状态">
                    <el-tag type="success">成功</el-tag>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
export default {
    name: 'basetable',
    data() {
        return {
            emsDatas: [{
                phone: '17391856792',
                name: '马帅',
                date: '2022-8-26 07:33:45',
                status: true
            },
            {
                phone: '18729089179',
                name: '喻越',
                date: '2022-8-26 07:33:45',
                status: true
            },
            {
                phone: '15102931686',
                name: '雷龙龙',
                date: '2022-8-26 07:33:45',
                status: true
            },
            {
                phone: '17719832715',
                name: '宁衡正',
                date: '2022-8-26 07:33:46',
                status: true
            },
            {
                phone: '13720755075',
                name: '刘丰',
                date: '2022-8-26 07:33:46',
                status: true
            },],
            smsVisible: true,
            videoVisible: false,
            confimPeopleShow: false,
            cofimTypeOptions: [
                {
                    value: '1',
                    label: '报警'
                },
                {
                    value: '2',
                    label: '测试'
                },
                {
                    value: '3',
                    label: '误报'
                },
                {
                    value: '4',
                    label: '演练'
                }
            ],
            cofimPeopleOptions: [],
            cofimTypeValue: '',
            cofimPeopleValue: '',
            tableDatas: [],
            query: {
                address: '',
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            // tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1
        };
    },
    activated() {
        this.getDataNow();
        this.getPeoples();
    },
    created() {
        this.getDataNow();
        this.getPeoples();
        // this.getData();
    },
    methods: {
        // 查看录像
        handleVedio(e1, e2) {
            console.log(e1);
            console.log(e2);
            this.videoVisible = true;
        },
        // 导出表格
        exportExcel() {
            console.log('打印');
            this.outToExcels.exportExcel(`${new Date().getTime()}报警记录.xlsx`, '#outExcel');
        },
        // 获取当前设备报警信息
        getDataNow() {
            let deviceArr = [];
            this.$store.state.deviceNowData.forEach(item => {
                if (item.status == '报警') {
                    deviceArr.push(item);
                }
            });
            let messageArr = [];
            this.$store.state.deviceMessage.forEach(item => {
                if (item.type == 'alarm' && item.status == 0) {
                    messageArr.push(item);
                }
            });

            let newArr = [];
            // 根据设备id查询message;
            deviceArr.forEach((item, index) => {
                messageArr.forEach((i, ind) => {
                    if (item.id == i.id) {
                        let obj = item;
                        obj.failDate = i.failDate;
                        obj.messageId = i.messageId;
                        newArr.push(obj);
                    }
                });
            });
            this.tableDatas = newArr;
            this.pageTotal = newArr.length;
        },

        // 监听派单选择器变化
        confimSelectChange(e) {
            if (e == 1 || e == 4) {
                this.confimPeopleShow = true;
            } else {
                this.confimPeopleShow = false;
                this.cofimPeopleValue = '';
            }
        },

        // 获取人员信息
        getPeoples() {
            let arr = this.$store.state.peoples.map(item => {
                item.value = item.id;
                item.label = item.name;
                return item;
            });
            let newArr = [];
            arr.forEach(item => {
                if (item.role == 3) {
                    newArr.push(item);
                }
            });
            this.cofimPeopleOptions = newArr;
        },

        // 确认指派
        saveEdit(e) {
            if (this.cofimTypeValue.trim() == '') {
                this.$message.error('未选择类型');
            } else if (this.cofimTypeValue != 1 && this.cofimTypeValue != 4) {
                console.log('this.form');
                console.log(this.form);

                // 测试或者误报  直接修改设备属性状态为正常并处理工单信息
                this.$store.commit('setDeviceNormalOne', this.form.id);
                this.$store.commit('setMessageSuccessOne', this.form.messageId);
                console.log(this.$store.state.deviceMessage);
                // 重新获取数据
                this.getDataNow();
                this.$message.success('处理完成');
                this.editVisible = false;
            } else {
                if (this.cofimPeopleValue == '') {
                    this.$message.error('未选择人员');
                } else {
                    console.log('选择了人员');
                    // 测试或者误报  直接修改设备属性状态为正常并处理工单信息
                    this.$store.commit('setDeviceNormalOne', this.form.id);
                    this.$store.commit('setMessageSuccessOne', this.form.messageId);
                    console.log(this.$store.state.deviceMessage);
                    // 重新获取数据
                    this.getDataNow();
                    this.$message.success('处理完成');
                    this.editVisible = false;
                }
            }
        },

        // 获取 easy-mock 的模拟数据
        // getData() {
        //     fetchData(this.query).then(res => {
        //         console.log(res);
        //         this.tableData = res.list;
        //         this.pageTotal = res.pageTotal || 50;
        //     });
        // },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            // this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$message.success('删除成功');
                    this.tableData.splice(index, 1);
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            // this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.videoClass {
    width: 100%;
}
</style>
